
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProgramPage = lazy(() => import('../pages/program/page'));
const PrintProgramPage = lazy(() => import('../pages/program/print/page'));
const SpeakersPage = lazy(() => import('../pages/speakers/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const AttendPage = lazy(() => import('../pages/attend/page'));
const BeirutPage = lazy(() => import('../pages/beirut/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/program',
    element: <ProgramPage />,
  },
  {
    path: '/program/print',
    element: <PrintProgramPage />,
  },
  {
    path: '/speakers',
    element: <SpeakersPage />,
  },
  {
    path: '/partners',
    element: <PartnersPage />,
  },
  {
    path: '/attend',
    element: <AttendPage />,
  },
  {
    path: '/beirut',
    element: <BeirutPage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
